import { createFileRoute, Navigate } from '@tanstack/react-router'

// Redirect shim: the old "Свободные" tab was merged into the registry (#262).
// Keeps old bookmarks and browser history working.
export const Route = createFileRoute('/_app/properties/available')({
	component: () => <Navigate to="/properties/registry" replace />,
})
